"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var components_1 = require("@theme-ui/components");
var core_1 = require("@theme-ui/core");
var react_1 = require("react");
var Image_1 = __importDefault(require("../Image"));
var helpers_1 = require("../ThemeProvider/helpers");
var Logo = function (_a) {
    var imageData = _a.imageData, alt = _a.alt, credits = _a.credits, className = _a.className, loading = _a.loading;
    return ((0, core_1.jsx)(components_1.AspectRatio, { ratio: 1 },
        (0, core_1.jsx)("div", { className: className, sx: {
                height: "100%",
                borderWidth: "1px",
                borderStyle: "solid",
                borderColor: function (theme) { var _a; return (0, helpers_1.getMostVisible)((_a = theme.rawColors) === null || _a === void 0 ? void 0 : _a.background, ["#eee"]).toHexString(); },
                padding: 2,
                borderRadius: "small",
                backgroundColor: "#fff",
            } },
            (0, core_1.jsx)(Image_1.default, { imageData: imageData, alt: alt, credits: credits, loading: loading, sx: {
                    height: "100%",
                    width: "100%",
                    borderRadius: "small",
                    objectFit: "contain",
                    clipPath: "content-box",
                    // @ts-expect-error force img style
                    "& img": {
                        objectFit: "contain ".concat("!important"),
                    },
                } }))));
};
exports.default = (0, react_1.memo)(Logo);
